import { sendRequest } from "../axios";
import moment from "moment";

export default {
  state: {
    newCalculation: true,
    banksTags: [],
    banksCS: [],
    productsCS: [],
    customersCS: [],
    situationsCS: [],
    currentBankCS: null,
    currentProductCS: {},
    productDataCS: {},
    currentCustomerCS: null,
    currentSituationCS: null,
    purchasesCS: [],
    acraCS: [],
    raexpertCS: [],
    purchasesValCS: [],
    calcSettingsTab: 1,
    situationsWithCommentCS: [],
    situationWithCommentCS: null,
    searchCS: "",
    sortCS: "bank_license",
    sortDesc: true,
    updateProductItemsPerPage: 15,

    searchBankCS: "",
    sortBankCS: "license",
    sortBankDesc: true,
    updateBankItemsPerPage: 10,
    websites: [],

    workAgent: [],
    selectedWorkAgent: 0,
  },
  mutations: {
    SET_WORK_AGENT_TAB(state, commit) {
      state.selectedWorkAgent = commit;
    },
    SET_WORK_AGENT(state, commit) {
      state.workAgent = commit;
    },
    ADD_WORK_AGENT(state, commit) {
      state.selectedWorkAgent = state.workAgent.length;
      state.workAgent.push(commit);
    },
    SET_BANKS_PER_PAGE_CS(state, commit) {
      state.updateBankItemsPerPage = commit;
    },
    SET_BANKS_TAGS(state, commit) {
      state.banksTags = commit;
    },
    SET_SORT_BANKS_CS(state, commit) {
      state.sortBankCS = commit;
    },
    SET_SORT_DESC_BANKS_CS(state, commit) {
      state.sortBankDesc = commit;
    },
    SET_SEARCH_BANKS_CS(state, commit) {
      state.searchBankCS = commit;
    },

    SET_PRODUCTS_PER_PAGE_CS(state, commit) {
      state.updateProductItemsPerPage = commit;
    },
    SET_SORT_CS(state, commit) {
      state.sortCS = commit;
    },
    SET_SORT_DESC_CS(state, commit) {
      state.sortDesc = commit;
    },
    SET_SEARCH_CS(state, commit) {
      state.searchCS = commit;
    },
    SET_NEW_CALCULATION(state, commit) {
      state.newCalculation = commit;
    },
    SET_CURRENT_SITUATIONSCS(state, commit) {
      state.situationsWithCommentCS = commit;
    },
    SET_CALC_SETTINGS_TAB(state, commit) {
      state.calcSettingsTab = commit;
    },
    SET_PRODUCTDATA(state, commit) {
      state.productDataCS = commit;
    },
    SET_BANKSCS(state, commit) {
      state.banksCS = commit;
    },
    SET_WEBSITES(state, commit) {
      const websites = Object.assign([], commit);
      state.websites = websites.sort((a, b) => a - b);
    },
    REMOVE_WEBSITES(state, payload) {
      state.websites = state.websites.filter((item) => item.id !== payload);
    },
    ADD_WEBSITES(state, commit) {
      state.websites.push(commit);
    },
    SET_PRODUCTSCS(state, commit) {
      state.productsCS = commit;
    },
    SET_CUSTOMERSCS(state, commit) {
      state.customersCS = commit;
    },
    SET_SITUATIONSCS(state, commit) {
      state.situationsCS = commit;
    },

    SET_CURRENT_BANKCS(state, commit) {
      state.currentBankCS = commit;
    },
    SET_CURRENT_PRODUCTCS(state, commit) {
      state.currentProductCS = commit;
    },
    SET_CURRENT_SITUATIONCS(state, commit) {
      state.currentSituationCS = commit;
    },
    SET_CURRENT_CUSTOMERCS(state, commit) {
      state.currentCustomerCS = commit;
    },

    SET_PURCHASESCS(state, payload) {
      state.purchasesCS = payload;
    },
    SET_ACRACS(state, payload) {
      state.acraCS = payload;
    },
    SET_RAEXPERTCS(state, payload) {
      state.raexpertCS = payload;
    },
    SET_NPA(state, payload) {
      state.npa = payload;
    },
    SET_NKP(state, payload) {
      state.nkp = payload;
    },
    SET_PURCHASESVALCS(state, payload) {
      state.purchasesValCS = payload;
    },
  },
  actions: {
    copyStandart({ state, commit }, item) {
      const WA = state.workAgent.filter((agent) => agent.id !== item.id);
      const stand = state.workAgent.find((agent) => agent.standart === 1);
      const newItem = JSON.parse(JSON.stringify(item));

      newItem.what_fee = stand.what_fee;

      if (stand.what_fee === "range") {
        newItem.agentsFeeMax = stand.agentsFeeMax;
        newItem.agentsFeeMaxType = stand.agentsFeeMaxType;
        newItem.agentsFeeMin = stand.agentsFeeMin;
        newItem.agentsFeeMinType = stand.agentsFeeMinType;
      }

      if (stand.what_fee === "netto") {
        newItem.nettoFee = stand.nettoFee;
        newItem.nettoFeeType = stand.nettoFeeType;
        newItem.nettoFeeMax = stand.nettoFeeMax;
        newItem.nettoFeeMaxType = stand.nettoFeeMaxType;
      }

      newItem.agentsupMax = stand.agentsupMax;
      newItem.agentsupMaxType = stand.agentsupMaxType;
      newItem.agentsupMin = stand.agentsupMin;
      newItem.agentsupMinType = stand.agentsupMinType;
      newItem.agentsup_note = stand.agentsup_note;
      newItem.agentsfee_note = stand.agentsfee_note;
      newItem.down_agent = stand.down_agent;
      newItem.down_bank = stand.down_bank;
      newItem.down_bank_agent = stand.down_bank_agent;
      newItem.down_description = stand.down_description;
      newItem.edo = stand.edo;
      newItem.edo_decada = stand.edo_decada;
      newItem.edo_mounth = stand.edo_mounth;
      newItem.edo_personal = stand.edo_personal;
      newItem.edo_sdelka = stand.edo_sdelka;
      newItem.edo_week = stand.edo_week;
      newItem.minFee = stand.minFee;
      newItem.minFeeType = stand.minFeeType;
      newItem.min_tarif = stand.min_tarif;
      newItem.min_tarif_note = stand.min_tarif_note;
      newItem.saleDate = [];
      newItem.standart = 0;
      newItem.up_box = stand.up_box;
      newItem.up_description = stand.up_description;

      commit(
        "SET_WORK_AGENT",
        [...WA, newItem].sort((a, b) => a.id - b.id)
      );
    },
    updateSaleList({ state }) {
      return new Promise((resolve) =>
        sendRequest(`saleFee`, "post", state.workAgent).then((res) => {
          resolve(true);
        })
      );
    },
    removeSale({ commit }, id) {
      return new Promise((resolve) =>
        sendRequest(`saleFee/${id}`, "delete").then((res) => {
          commit("SET_WORK_AGENT_TAB", res.data.length - 1);
          commit("SET_WORK_AGENT", res.data);
        })
      );
    },
    getAllSale({ commit }, data) {
      return new Promise((resolve) =>
        sendRequest(`saleFee/${data.bank_id}/${data.product_id}`, "get").then(
          (res) => {
            commit("SET_WORK_AGENT", res.data);
            resolve(res.data.length ? true : false);
          }
        )
      );
    },
    addSale({ commit }, data) {
      return new Promise((resolve) =>
        sendRequest(
          `saleFee/${data.bank_id}/${data.product_id}/${data.standart}`,
          "put"
        ).then((res) => {
          const sale = res.data;
          const date = [];
          const nowDate = moment().format("YYYY-MM-DD");
          const date_to = moment(nowDate)
            .add(this.days, "days")
            .format("YYYY-MM-DD");
          date.push(nowDate);
          date.push(date_to);

          sale.saleDate = date;
          commit("ADD_WORK_AGENT", sale);
        })
      );
    },
    MAKE_BACKUP() {
      return new Promise((resolve) =>
        sendRequest("BackupToTest", "get").then((res) => {
          resolve(res.data);
        })
      );
    },
    ChangeTab({ commit }, data) {
      commit("SET_CALC_SETTINGS_TAB", data);
    },
    GetBanksTags({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("banksTags/", "get").then((response) => {
          commit("SET_BANKS_TAGS", response.data);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    AddBanksTag({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("banksTags/", "post", data).then((response) => {
          commit("SET_BANKS_TAGS", response.data);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    DeleteBanksTag({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`banksTags/${id}`, "delete").then((response) => {
          commit("SET_BANKS_TAGS", response.data);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    updateSituationCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("updateSituation/" + data.id, "put", data).then(
          (response) => {
            commit("SET_SITUATIONSCS", response.data.situations);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    removeSituationCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          "removeSituation/" + data.id,
          "put",
          undefined,
          reject
        ).then((response) => {
          commit("SET_SITUATIONSCS", response.data.situations);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    updateCustomerCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("updateCustomer/" + data.id, "put", data).then(
          (response) => {
            commit("SET_CUSTOMERSCS", response.data.customers);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateBankCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("CalculatorBank/" + data.id, "put", data).then(
          (response) => {
            commit("SET_BANKSCS", response.data.bank);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateProductCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("CalculatorRate/" + data.id, "put", data, reject).then(
          (response) => {
            commit("SET_PRODUCTSCS", response.data.products);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },

    SaveNewBankCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("CalculatorBank", "post", data).then((response) => {
          commit("SET_BANKSCS", response.data.bank);

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    SaveNewProductCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("CalculatorRate", "post", data, reject).then((response) => {
          commit("SET_PRODUCTSCS", response.data.products);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    SaveNewCustomerCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("addCustomer", "post", data).then((response) => {
          commit("SET_CUSTOMERSCS", response.data.customers);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    SaveNewSituationCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("addSituation", "post", data).then((response) => {
          commit("SET_SITUATIONSCS", response.data.situations);

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    addBankCS({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("getBankRekvInfo", "get", undefined, reject).then(
          (response) => {
            //commit('SET_CURRENT_BANKCS',response.data.bank);
            commit("SET_PURCHASESCS", response.data.purchase);
            commit("SET_ACRACS", response.data.acra);
            commit("SET_RAEXPERTCS", response.data.raexpert);
            commit("SET_PURCHASESVALCS", []);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    addProductCS({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("getProductRekvInfo", "get", undefined, reject).then(
          (response) => {
            var currentProduct = [];
            var varNameArr = [
              "bank",
              "limit",
              "usn",
              "osob",
              "preview",
              "agentsup",
              "agentsdown",
              "tariff",
              "accreditation",
              "principal",
              "request",
              "bail",
              "account",
              "paper",
              "other",
              "life",
              "practice",
              "fns",
              "third",
              "edo",
              "purchase",
              "guarantee",
              "packet",
              "method",
              "time",
              "agentsfee",
              "reloadbg",
              "gar_polz_zak",
              "your_situation",
            ];
            for (var i = 0; i < varNameArr.length; i++) {
              currentProduct[varNameArr[i] + "s"] =
                response.data[varNameArr[i]];
            }

            commit("SET_PRODUCTDATA", currentProduct);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    addCustomerCS({ commit }) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_CUSTOMERCS", {});
      commit("SET_PROCESSING", false);
    },
    addSituationCS({ commit }) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_SITUATIONCS", {});
      commit("SET_PROCESSING", false);
    },

    getProductCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`CalculatorRate/${data}`, "get", undefined, reject).then(
          (response) => {
            commit("SET_CURRENT_SITUATIONSCS", response.data.situations);
            commit("SET_CURRENT_PRODUCTCS", response.data.rate);

            const currentProduct = {
              banks: response.data.bank,
              limits: response.data.limit,
              usns: response.data.usn,
              osobs: response.data.osob,
              previews: response.data.preview,
              agentsups: response.data.agentsup,
              agentsdowns: response.data.agentsdown,
              reloadbgs: response.data.reloadbg,
            };

            var varNameArr = [
              "tariff",
              "accreditation",
              "principal",
              "request",
              "bail",
              "account",
              "paper",
              "other",
              "life",
              "practice",
              "fns",
              "third",
              "edo",
              "purchase",
              "guarantee",
              "packet",
              "method",
              "time",
              "agentsfee",
              "gar_polz_zak",
              "your_situation",
            ];
            for (var i = 0; i < varNameArr.length; i++) {
              currentProduct[varNameArr[i] + "s"] =
                response.data[varNameArr[i]];
              if (response.data.rate[varNameArr[i]]) {
                currentProduct[varNameArr[i] + "sVal"] = response.data.rate[
                  varNameArr[i]
                ]
                  .split(",")
                  .map((string) => parseInt(string));
              } else {
                currentProduct[varNameArr[i] + "sVal"] = null;
              }
            }

            commit("SET_PRODUCTDATA", currentProduct);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    deleteProductCS({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`CalculatorRate/${data}`, "delete").then(
          (response) => {
            dispatch('GetCalcSettingsCS')
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getBankCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`CalculatorBank/${data}`, "get", undefined, reject).then(
          (response) => {
            commit("SET_CURRENT_BANKCS", response.data.bank);
            commit("SET_PURCHASESCS", response.data.purchase);
            commit("SET_ACRACS", response.data.acra);
            commit("SET_RAEXPERTCS", response.data.raexpert);
            commit("SET_NPA", response.data.npa);
            commit("SET_NKP", response.data.nkp);
            if (response.data.bank.list) {
              var purchaseVal = response.data.bank.list
                .split(",")
                .map((string) => parseInt(string));
              commit("SET_PURCHASESVALCS", purchaseVal);
            } else {
              commit("SET_PURCHASESVALCS", []);
            }

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getCustomerCS({ commit }, data) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_CUSTOMERCS", data);
      commit("SET_PROCESSING", false);
    },
    getSituationCS({ commit }, data) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_SITUATIONCS", data);
      commit("SET_PROCESSING", false);
    },
    addSituationComment({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          "addSituationComment/" + payload.id,
          "post",
          payload.formData,
          reject
        ).then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    editSituationComment({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          "editSituationComment/" + payload.id,
          "post",
          payload.formData,
          reject
        ).then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    deleteSituationComment({ commit }, formData) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("deleteSituationComment/", "post", formData, reject).then(
          (response) => {
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    GetCalcSettingsCS({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("CalculatorSettingsSimple", "get").then((response) => {
          commit("SET_WEBSITES", response.data.websites);
          commit("SET_BANKSCS", response.data.banks);
          commit("SET_PRODUCTSCS", response.data.products);
          commit("SET_CUSTOMERSCS", response.data.customers);
          commit("SET_SITUATIONSCS", response.data.situations);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },

    RefreshProductsCS({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("CalculatorProductsSimple", "get").then((response) => {
          commit("SET_PRODUCTSCS", response.data.products);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getAllWebsite({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("website", "get").then((response) => {
          commit("SET_WEBSITES", response.data);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getWebsite({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`website/${id}`, "get").then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    addWebsite({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("website", "post", { name: payload }).then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    editWebsite({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("website", "put", payload).then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    removeWebsite({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`website/${payload}`, "delete").then((response) => {
          commit("REMOVE_WEBSITES", payload);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getCalcSettingsProcent({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`calcSettingProcent`, "get").then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    setCalcSettingsProcent({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`calcSettingProcent`, "post", payload).then((response) => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    }
  },
  getters: {
    GetCalcSettingsTab: (state) => state.calcSettingsTab,
    getBanksCS: (state) => state.banksCS,
    getProductsCS: (state) => state.productsCS,
    getCurrentBankCS: (state) => state.currentBankCS,
    getProductCS: (state) => state.currentProductCS,
    getCurrentCustomerCS: (state) => state.currentCustomerCS,
    getCurrentSituationCS: (state) => state.currentSituationCS,
    getCustomersCS: (state) => state.customersCS,
    getSituationsCS: (state) => state.situationsCS,
    getPurchasesValCS: (state) => state.purchasesValCS,
    getPurchasesCS: (state) => state.purchasesCS,
    getAcraCS: (state) => state.acraCS,
    getRaExperdCS: (state) => state.raexpertCS,
    getNKP: (state) => state.nkp,
    getNPA: (state) => state.npa,
    getProductData: (state) => state.productDataCS,
    getSituationsWithCommentCS: (state) => state.situationsWithCommentCS,
    getNewCalculation: (state) => state.newCalculation,

    getSortCS: (state) => state.sortCS,
    getSortDescCS: (state) => state.sortDesc,
    getSearchCS: (state) => state.searchCS,
    getProductItemsPerPage: (state) => state.updateProductItemsPerPage,

    getSortBankCS: (state) => state.sortBankCS,
    getSortDescBankCS: (state) => state.sortBankDesc,
    getSearchBankCS: (state) => state.searchBankCS,
    getBankPerPage: (state) => state.updateBankItemsPerPage,
    getWebsites: (state) => state.websites,
    getBanksTags: (state) => state.banksTags,
    getWorkAgent: (state) => state.workAgent,
    getSelectedWorkAgent: (state) => state.selectedWorkAgent,
  },
};
